import 'slick-carousel';

export default {
  init() {
    // JavaScript to be fired on all pages
    jQuery(window).on('scroll', function () {
      var scroll = jQuery(window).scrollTop();
     
      if (scroll > 0) {
        jQuery('body').addClass('scrolling');
        jQuery('header.banner #topBar').addClass('fixed-top');
        $('.block-SEO:not(.loaded)').addClass('closed').addClass('loaded');
        $('.block-media-and-text_content:NOT(.loaded)').addClass('closed').addClass('loaded');
        jQuery('.block.block-floating-buttons').addClass('fixed-right');
        jQuery('.joinchat.joinchat--right.joinchat--show').addClass('fixed-right');

      } else {
        jQuery('body').removeClass('scrolling');
        jQuery('header.banner #topBar').removeClass('fixed-top');
        jQuery('.block.block-floating-buttons').removeClass('fixed-right');
        jQuery('.joinchat.joinchat--right.joinchat--show').removeClass('fixed-right');
      }
    });
    
    jQuery('.block-SEO').on('click','a.seo-title-opener',function(t){
      t.preventDefault();
      
      if(jQuery('.seo-content').hasClass('slide-top')){
        jQuery('.seo-content').removeClass('slide-top');
        jQuery('.seo-content').addClass('slide-bottom');
        jQuery(t.target).closest('.block-SEO').addClass('closed');
      }else{

        if(jQuery('.seo-content').hasClass('slide-bottom')){
          jQuery('.seo-content').removeClass('slide-bottom');
          jQuery('.seo-content').addClass('slide-top');
          jQuery(t.target).closest('.block-SEO').removeClass('closed');
        }
      }
    })

    jQuery('.block-SEO').on('click','a.seo-opener',function(t){
      t.preventDefault();
      
      if(jQuery('.seo-content').hasClass('slide-top')){
        jQuery('.seo-content').removeClass('slide-top');
        jQuery('.seo-content').addClass('slide-bottom');
      }

      jQuery(t.target).closest('.block-SEO').removeClass('closed');
      jQuery('.seo-actions').addClass('mt16');
    })

    jQuery('.block-SEO').on('click','a.seo-closer',function(t){
      t.preventDefault();
      
      if(jQuery('.seo-content').hasClass('slide-bottom')){
        jQuery('.seo-content').removeClass('slide-bottom');
        jQuery('.seo-content').addClass('slide-top');
      }
     
      jQuery(t.target).closest('.block-SEO').addClass('closed');
      jQuery('.seo-actions').removeClass('mt16');
    })

    jQuery('.block-media-and-text_content').on('click','a.seo-opener',function(t){
      t.preventDefault();
      
      if(jQuery('.seo-content').hasClass('slide-top')){
        jQuery('.seo-content').removeClass('slide-top');
        jQuery('.seo-content').addClass('slide-bottom');
      }
      jQuery(t.target).closest('.block-media-and-text_content').removeClass('closed');
    })

    jQuery('.block-media-and-text_content').on('click','a.seo-closer',function(t){
      t.preventDefault();
      
      if(jQuery('.seo-content').hasClass('slide-bottom')){
        jQuery('.seo-content').removeClass('slide-bottom');
        jQuery('.seo-content').addClass('slide-top');
      }
     
      jQuery(t.target).closest('.block-media-and-text_content').addClass('closed')
    })

    //slider de servicios de particulares
    jQuery('.block.block-more-services .wrap-services').slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: '<div class="slick-prev"><svg class="icoprev" width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.654542 9.99838L9.58871 1.06422C10.4352 0.219937 11.9004 0.219937 12.7469 1.06421C13.618 1.9353 13.618 3.35136 12.7469 4.22244L5.39188 11.5775L12.7469 18.9326C13.1691 19.3547 13.4014 19.9153 13.4014 20.5117C13.4014 21.108 13.1691 21.6686 12.7469 22.0908C12.3114 22.5263 11.7396 22.7452 11.1678 22.7452C10.596 22.7452 10.0243 22.5263 9.58871 22.093L0.654542 13.1588C0.232403 12.7345 0.000111609 12.1739 0.000111557 11.5775C0.000111505 10.9811 0.232403 10.4205 0.654542 9.99838Z" fill="#36A9E1"/></svg></div>',
      nextArrow: '<div class="slick-next"><svg class="iconext" width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7458 13.178L3.81168 22.1121C2.96517 22.9564 1.49996 22.9564 0.653451 22.1121C-0.21763 21.2411 -0.21763 19.825 0.653451 18.9539L8.0085 11.5989L0.653451 4.24381C0.231312 3.82167 -0.000976548 3.26105 -0.000976551 2.66469C-0.000976554 2.06834 0.231312 1.50772 0.653451 1.08558C1.08899 0.65004 1.66078 0.431152 2.23257 0.431152C2.80435 0.431152 3.37614 0.65004 3.81168 1.08335L12.7458 10.0175C13.168 10.4419 13.4003 11.0025 13.4003 11.5989C13.4003 12.1952 13.168 12.7558 12.7458 13.178Z" fill="#36A9E1"/></svg></div>',
      responsive: [
        {
          breakpoint: 1239,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: false,
          },
        },{
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            dots: false,
          },
        },
      ],

    });

    //slider últimas noticias
    if ( screen.width < 1240 ) {
      jQuery('.block.block-last-news .content-post .wrap_post').slick({
        dots: false,
        infinite: false,
        arrows: true,
        speed: 300,
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><svg class="icoprev" width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.654542 9.99838L9.58871 1.06422C10.4352 0.219937 11.9004 0.219937 12.7469 1.06421C13.618 1.9353 13.618 3.35136 12.7469 4.22244L5.39188 11.5775L12.7469 18.9326C13.1691 19.3547 13.4014 19.9153 13.4014 20.5117C13.4014 21.108 13.1691 21.6686 12.7469 22.0908C12.3114 22.5263 11.7396 22.7452 11.1678 22.7452C10.596 22.7452 10.0243 22.5263 9.58871 22.093L0.654542 13.1588C0.232403 12.7345 0.000111609 12.1739 0.000111557 11.5775C0.000111505 10.9811 0.232403 10.4205 0.654542 9.99838Z" fill="#36A9E1"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg class="iconext" width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7458 13.178L3.81168 22.1121C2.96517 22.9564 1.49996 22.9564 0.653451 22.1121C-0.21763 21.2411 -0.21763 19.825 0.653451 18.9539L8.0085 11.5989L0.653451 4.24381C0.231312 3.82167 -0.000976548 3.26105 -0.000976551 2.66469C-0.000976554 2.06834 0.231312 1.50772 0.653451 1.08558C1.08899 0.65004 1.66078 0.431152 2.23257 0.431152C2.80435 0.431152 3.37614 0.65004 3.81168 1.08335L12.7458 10.0175C13.168 10.4419 13.4003 11.0025 13.4003 11.5989C13.4003 12.1952 13.168 12.7558 12.7458 13.178Z" fill="#36A9E1"/></svg></div>',
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
            },
          },{
            breakpoint: 375,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
            },
          },
        ],
      });

    }

    jQuery('.nextpostslink').html('<svg class="iconext" width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7458 13.178L3.81168 22.1121C2.96517 22.9564 1.49996 22.9564 0.653451 22.1121C-0.21763 21.2411 -0.21763 19.825 0.653451 18.9539L8.0085 11.5989L0.653451 4.24381C0.231312 3.82167 -0.000976548 3.26105 -0.000976551 2.66469C-0.000976554 2.06834 0.231312 1.50772 0.653451 1.08558C1.08899 0.65004 1.66078 0.431152 2.23257 0.431152C2.80435 0.431152 3.37614 0.65004 3.81168 1.08335L12.7458 10.0175C13.168 10.4419 13.4003 11.0025 13.4003 11.5989C13.4003 12.1952 13.168 12.7558 12.7458 13.178Z" fill="#36A9E1"/></svg>');
    jQuery('.prevpostslink').html('<svg class="icoprev" width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.654542 9.99838L9.58871 1.06422C10.4352 0.219937 11.9004 0.219937 12.7469 1.06421C13.618 1.9353 13.618 3.35136 12.7469 4.22244L5.39188 11.5775L12.7469 18.9326C13.1691 19.3547 13.4014 19.9153 13.4014 20.5117C13.4014 21.108 13.1691 21.6686 12.7469 22.0908C12.3114 22.5263 11.7396 22.7452 11.1678 22.7452C10.596 22.7452 10.0243 22.5263 9.58871 22.093L0.654542 13.1588C0.232403 12.7345 0.000111609 12.1739 0.000111557 11.5775C0.000111505 10.9811 0.232403 10.4205 0.654542 9.99838Z" fill="#36A9E1"/></svg>');

    //bubble navigation
    if ( screen.width < 1240 ) {
      jQuery('.block.block-bubble-navigation .navigation').on('click','.bubble_nav.complex_link', function(t){
        t.preventDefault();
        var bubbleLink;
  
        if($(this).children('.bubble_mnu').hasClass('slide-in-top-bubble')) {
          $(this).children('.bubble_mnu').removeClass('slide-in-top-bubble');
          bubbleLink = $(this).children('a.complex_link.hasSubmenu');
          $(this).removeClass('mb-0');
          $(bubbleLink).children('.fade-in-fwd').removeClass('drop-shadow');
        }else{
          jQuery('.block.block-bubble-navigation .navigation .bubble_nav.complex_link').children('.bubble_mnu').removeClass('slide-in-top-bubble');
          jQuery(this).addClass('mb-0');
          bubbleLink = $(this).children('.complex_link.hasSubmenu');
          $(bubbleLink).children('.fade-in-fwd').addClass('drop-shadow');
          $(this).children('.bubble_mnu').addClass('slide-in-top-bubble');
        }
      })
    }else{
      jQuery('.block.block-bubble-navigation .navigation').on('mouseover','.bubble_nav.complex_link', function(t){
        t.preventDefault();
        var bubbleLink;

        jQuery('.block.block-bubble-navigation .navigation .bubble_nav.complex_link').children('.bubble_mnu').removeClass('slide-in-top-bubble'); 
          bubbleLink = $(this).children('.complex_link.hasSubmenu'); 
          jQuery(this).addClass('mb-0');
          $(bubbleLink).children('.fade-in-fwd').addClass('drop-shadow');
          $(this).children('.bubble_mnu').addClass('slide-in-top-bubble');

      })

      jQuery('.block.block-bubble-navigation .navigation').on('mouseleave','.bubble_nav.complex_link', function(t){
        t.preventDefault();
        var bubbleLink;

        if($(this).children('.bubble_mnu').hasClass('slide-in-top-bubble')) {
          $(this).children('.bubble_mnu').removeClass('slide-in-top-bubble');
          bubbleLink = $(this).children('a.complex_link.hasSubmenu');
          $(this).removeClass('mb-0');
          $(bubbleLink).children('.fade-in-fwd').removeClass('drop-shadow');
        }

      })
    }
    
    jQuery('.container.block.block-more-services .wrap-services').on('mouseover', '.service', function(t){
      t.preventDefault();
      var initialBackGroundImage = $(this).css('background-image');
      var blueGradient = 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), linear-gradient(0deg, #38a8df, #38a8df)';
      var urlBackground = initialBackGroundImage.substring(initialBackGroundImage.indexOf('url'), initialBackGroundImage.length);

      var services = jQuery('.container.block.block-more-services .wrap-services .service');

      var i=0;
      while(services[i])
      {
      
        var itemBackgroundImage = services[i].style.backgroundImage;
        
        if(initialBackGroundImage != itemBackgroundImage)
        {
          var urlBackgroundItem = itemBackgroundImage.substring(itemBackgroundImage.indexOf('url'), itemBackgroundImage.length);
          
          services[i].style.backgroundImage = urlBackgroundItem;
        }
        i++;
      }
      $(this).css('background-image', blueGradient + ', ' + urlBackground);
     
    })

    jQuery('.container.block.block-more-services .wrap-services').on('mouseleave', '.service', function(t){
      t.preventDefault();
      
      var initialBackGroundImage = $(this).css('background-image');
      var urlBackground = initialBackGroundImage.substring(initialBackGroundImage.indexOf('url'), initialBackGroundImage.length);

      $(this).css('background-image', urlBackground);

    })

    jQuery('.container.block.block-more-services .wrap-services .service.half').on('mouseover', '.half_service', function(t){
      t.preventDefault();
      var initialBackGroundImage = $(this).css('background-image');
      var blueGradient = 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), linear-gradient(0deg, #38a8df, #38a8df)';
      var urlBackground = initialBackGroundImage.substring(initialBackGroundImage.indexOf('url'), initialBackGroundImage.length);

      var services = jQuery('.container.block.block-more-services .wrap-services .service.half .half_service');

      var i=0;
      while(services[i])
      {
      
        var itemBackgroundImage = services[i].style.backgroundImage;
        
        if(initialBackGroundImage != itemBackgroundImage)
        {
          var urlBackgroundItem = itemBackgroundImage.substring(itemBackgroundImage.indexOf('url'), itemBackgroundImage.length);
          
          services[i].style.backgroundImage = urlBackgroundItem;
        }
        i++;
      }
      $(this).css('background-image', blueGradient + ', ' + urlBackground);
     
    })

    jQuery('.container.block.block-more-services .wrap-services .service.half').on('mouseleave', '.half_service', function(t){
      t.preventDefault();
      
      var initialBackGroundImage = $(this).css('background-image');
      var urlBackground = initialBackGroundImage.substring(initialBackGroundImage.indexOf('url'), initialBackGroundImage.length);

      $(this).css('background-image', urlBackground);

    })
  },
  finalize() {
    document.querySelectorAll('.jet-fb-form-block').forEach(function (container) {
      function moveToTop(el) {
        container.insertBefore(el, container.firstChild);
      }

      // submit-type-reload: mensajes ya presentes en el DOM al cargar
      var existingWrap = container.querySelector('.jet-form-builder-messages-wrap');
      if (existingWrap && existingWrap.children.length > 0) {
        moveToTop(existingWrap);
      }
      container.querySelectorAll(':scope > .jet-form-builder-message--error, :scope > .jet-form-builder-message--success').forEach(function (node) {
        moveToTop(node);
      });

      // submit-type-ajax: JFB inyecta dentro del <form> — necesitamos subtree:true
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          // Nodo nuevo añadido en cualquier punto del árbol
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.classList.contains('jet-form-builder-message--error') ||
                node.classList.contains('jet-form-builder-message--success')) {
              moveToTop(node);
            }
            if (node.classList.contains('jet-form-builder-messages-wrap') && node.children.length > 0) {
              moveToTop(node);
            }
          });
          // JFB inyectó hijos en un messages-wrap ya existente (dentro o fuera del form)
          if (mutation.target &&
              mutation.target.classList &&
              mutation.target.classList.contains('jet-form-builder-messages-wrap') &&
              mutation.target.children.length > 0) {
            moveToTop(mutation.target);
          }
        });
      }).observe(container, { childList: true, subtree: true });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js